"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackConsentLevelSet = trackConsentLevelSet;
const genericTrackingData_1 = require("./genericTrackingData");
const cookies_1 = require("./cookies");
function trackConsentLevelSet(segmentWriteKey) {
    var _a;
    const genericTrackingData = (0, genericTrackingData_1.getGenericTrackingData)();
    const fcId = (0, cookies_1.getSessionId)();
    (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.track('consent_level_set', Object.assign(Object.assign({}, genericTrackingData), { category: 'consent_level', label: window.OnetrustActiveGroups, segmentWriteKey,
        fcId }), {});
}
//# sourceMappingURL=trackingHelper.js.map